import { Component, ViewChild } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ClientgroupMasterServiceService } from '../../Model/ClientGroupMaster/clientgroup-master-service.service';
import { SessionService } from '../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { CommonModule } from '@angular/common';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../Model/Common/common.service';
import { DownloadSampleService } from '../../Model/DownloadSample/download-sample.service';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-client-group-view',
  standalone: true,
  imports: [DataTablesModule, CommonModule, LoaderComponent],
  templateUrl: './client-group-view.component.html',
  styleUrl: './client-group-view.component.scss'
})
export class ClientGroupViewComponent {
  isDisabled: boolean = false;
  ClientData = [];
  ClientMasterExcel: any[] = [];
  editMode: boolean = false;
  User: any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(private router: Router,
    private clientgroupservice: ClientgroupMasterServiceService,
    protected common: CommonService,
    private session: SessionService,
    private download: DownloadSampleService,
    private toast: ToastService
  ) { 
    this.common.getPageRights(); 
    this.dtoptions = { ...this.common.commonDToptions };
    this.User = session.GetUserDetails();
  }

  ngOnInit(): void {
    this.getData();
    this.common.CheckExpiry();
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  getData() {
    const Detail = {
      SelectType: 1,
      ClientGroupMasterID: ''
    }
    this.isDisabled = true;
    this.clientgroupservice.ClientLoad(Detail).subscribe({
      next: (data) => {
        console.log('API Response:', data);
        this.ClientData = data.Table;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
    this.editMode = false;
  }
  navigateToLocationComponent() {
    this.editMode = false
    this.router.navigate(['master/Client']);
  }
  onEditClick(element: any): void {
    let navigationID: NavigationExtras = {
      queryParams: {
        editMode: true,
        SelectType: '2',
        ClientGroupMasterID: element.ClientGroupMasterID
      }
    };
    this.router.navigate(['master/Client'], navigationID);
  }

  excelDownload(){
    this.common.ExcelDump('Client', this.ClientData);
  }

  exportToExcel(filename: string) {
      this.isDisabled = true
      const data = {
        SelectType: 'ClientMasterExcel',
        Year: '',
        LoginUserId : this.User.UserId
      }
      this.download.ESS_ExcelDump(data).subscribe(
        (data: any) => {
          this.ClientMasterExcel = data;
          if (this.ClientMasterExcel.length > 0) {
            this.download.exportToExcel(this.ClientMasterExcel, filename);
            this.isDisabled = false
          }
          else {
            this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
            this.isDisabled = false
          }
        });
    }
}